import { forwardRef } from 'react'
import { TextInput } from '@carbon/react'
import type { TextInputProps } from '@carbon/react'
import type { FormNumberInputProps } from './types'
import { narrowToStringOrNumber } from './utils'
import { FormFieldLabel } from './FormFieldLabel'
import styles from './FormField.module.scss'

export const FormNumberInput = forwardRef<
  HTMLInputElement,
  FormNumberInputProps
>(
  (
    {
      label,
      error,
      required,
      hint,
      className = '',
      min,
      max,
      step,
      defaultValue,
      value,
      onClick,
      size,
      ...props
    },
    ref
  ) => {
    const fieldId = props.id || props.name || `number-${Math.random()}`

    const textInputProps: TextInputProps = {
      ...props,
      type: 'number',
      min,
      max,
      step,
      size: 'lg',
      defaultValue: narrowToStringOrNumber(defaultValue),
      value: narrowToStringOrNumber(value),
      id: fieldId,
      labelText: <FormFieldLabel label={label} required={required} />,
      invalid: !!error,
      invalidText: error,
      helperText: hint && !error ? hint : undefined,
      ...(onClick && { onClick: onClick as TextInputProps['onClick'] }),
    }

    return (
      <div className={`${styles.wrapper} ${className}`}>
        <div className={styles.fieldWrapper}>
          <TextInput ref={ref} {...textInputProps} />
        </div>
      </div>
    )
  }
)

FormNumberInput.displayName = 'FormNumberInput'
